import { Controller, useForm } from "react-hook-form";
import { Button, Form } from "reactstrap";
import { useEffect, useState } from "react";
import { TextAreaField, InputField, SelectionField, NumberInputField } from "../../../CommonElements";
import { useTandaTerima } from "../../../Context/TandaTerimaContext";

const FormTandaTerima = ({ resetState, toggle, data }) => {
  const tandaTerimaAPI = useTandaTerima();
  const { control, handleSubmit } = useForm({ defaultValues: data });
  const [unitKerjaOptions, setUnitKerjaOptions] = useState([]);

  const updateItem = (data) => {
    tandaTerimaAPI.updateTandaTerima(data.id_tanda_terima, data).then(() => {
      resetState();
      toggle();
    });
  };

  const createItem = (data) => {
    tandaTerimaAPI.createTandaTerima(data).then(() => {
      resetState();
      toggle();
    });
  };

  let isMounted = true;
  useEffect(() => {
    unitKerja();

    return () => {
      isMounted = false;
    };
  }, []);

  const unitKerja = async () => {
    tandaTerimaAPI.getUnitKerja().then((res) => {
      const unitKerja = res.data.map((item) => ({
        id: item.id_unit_kerja,
        name: item.nama_unit_kerja,
      }));
      setUnitKerjaOptions(unitKerja);
    });
  };

  const satuanLampiranOptions = [
    {
      id: "berkas",
      name: "berkas"
    },
    {
      id: "rangkap", 
      name: "rangkap"
    },
    {
      id: "lembar",
      name: "lembar"
    },
  ]

  return (
    <Form onSubmit={data ? handleSubmit(updateItem) : handleSubmit(createItem)}>
      <Controller
        name="dari"
        control={control}
        rules={{
          required: "Harap masukkan dari",
        }}
        render={({ field, fieldState }) => (
          <InputField
            label={"Dari"}
            defaultValues={data?.dari}
            fieldState={fieldState}
            {...field}
            isRequired
          />
        )}
      />
      <Controller
        name="unit_kerja"
        control={control}
        render={({ field, fieldState }) => (
          <SelectionField
            label={"Divisi"}
            defaultValues={data?.unit_kerja}
            fieldState={fieldState}
            options={unitKerjaOptions}
            {...field}
          />
        )}
      />
      <Controller
        name="nomor_surat"
        control={control}
        render={({ field, fieldState }) => (
          <InputField
            label={"Nomor Surat"}
            defaultValues={data?.nomor_surat}
            fieldState={fieldState}
            {...field}
          />
        )}
      />
      <Controller
        name="perihal"
        control={control}
        rules={{
          required: "Harap masukkan perihal",
        }}
        render={({ field, fieldState }) => (
          <InputField
            label={"Perihal"}
            defaultValues={data?.perihal}
            fieldState={fieldState}
            {...field}
            isRequired
          />
        )}
      />
      <Controller
        name="lampiran"
        control={control}
        render={({ field, fieldState }) => (
          <NumberInputField
            label={"Jumlah Lampiran"}
            defaultValues={data?.lampiran}
            fieldState={fieldState}
            min={0}
            {...field}
          />
        )}
      />
      <Controller
        name="satuan_lampiran"
        control={control}
        render={({ field, fieldState }) => (
          <SelectionField
            label={"Satuan Berkas Lampiran"}
            defaultValues={data?.satuan_lampiran}
            fieldState={fieldState}
            options={satuanLampiranOptions}
            {...field}
          />
        )}
      />
      <Controller
        name="isi_lampiran"
        control={control}
        render={({ field, fieldState }) => (
          <TextAreaField
            label={"Isi Lampiran"}
            defaultValues={data?.isi_lampiran}
            fieldState={fieldState}
            {...field}
            tooltip={
              `Tekan Enter jika terdapat lebih dari satu isi lampiran\ncontoh:\nFotokopi Kartu Keluarga\nFotokopi KTP`
            }
            />
          )}
      />
      <Controller
        name="catatan"
        control={control}
        render={({ field, fieldState }) => (
          <TextAreaField
          label={"Catatan"}
          defaultValues={data?.catatan}
          fieldState={fieldState}
          {...field}
          />
        )}
        />
      <Controller
        name="penerima"
        control={control}
        render={({ field, fieldState }) => (
          <TextAreaField
          label={"Kepada"}
          defaultValues={data?.penerima}
          fieldState={fieldState}
          {...field}
          tooltip={
            `Tekan Enter jika terdapat lebih dari satu penerima\ncontoh:\npenerima 1\npenerima 2`
          }
          />
        )}
      />
      <Controller
        name="pemberi_tugas"
        control={control}
        rules={{
          required: "Harap masukkan pemberi tugas",
        }}
        render={({ field, fieldState }) => (
          <InputField
            label={"Pemberi Tugas"}
            defaultValues={data?.pemberi_tugas}
            fieldState={fieldState}
            {...field}
            isRequired
          />
        )}
      />
      <Button color="primary">Simpan</Button>
    </Form>
  );
};

export default FormTandaTerima;
